import buildTheme from './theme_builder';
/* eslint-disable */

const colorPalette = ['#FF671D', '#FF8F88', '#A952A5', '#786099', '#0080BB', '#10CFC9', '#F69627'];

const theme = buildTheme(colorPalette);

export default theme;
